(function () {
  if (customElements.get("splide-component")) return;

  const arrowSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><path d="m15.5 8 12 12-12 12-2.9-2.9 9.1-9.1-9.1-9.1z"/></svg>';

  class SplideComponent extends HTMLElement {
    connectedCallback() {
      this.mount();
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this._resize);
      clearInterval(this._autoplay);
    }

    mount() {
      this.splide = this.querySelector(".splide");
      this.track = this.querySelector(".splide__track");
      this.list = this.querySelector(".splide__list");
      this.slides = Array.from(this.querySelectorAll(".splide__slide"));
      if (!this.splide || !this.track || !this.list || this.slides.length < 2) return;

      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains("is-active")));
      if (this.index < 0) this.index = 0;
      this.type = this.dataset.type || "slide";
      this.loop = this.type === "loop";
      this.fade = this.type === "fade";
      this.isRtl = document.documentElement.dir === "rtl";
      this.splide.classList.toggle("splide--fade", this.fade);

      this.ensureControls();
      this.bind();
      this.go(this.index, false);

      if (this.dataset.autoplay === "true") {
        const speed = Math.max(1, parseFloat(this.dataset.autoplaySpeed || "5")) * 1000;
        this._autoplay = setInterval(() => this.next(), speed);
      }
    }

    ensureControls() {
      const arrows = this.querySelector(".splide__arrows");
      if (arrows && !arrows.children.length) {
        arrows.innerHTML = [
          '<button class="splide__arrow splide__arrow--prev" type="button" aria-label="Previous slide">' + arrowSvg + "</button>",
          '<button class="splide__arrow splide__arrow--next" type="button" aria-label="Next slide">' + arrowSvg + "</button>",
        ].join("");
      }

      const pagination = this.querySelector(".splide__pagination");
      if (pagination && !pagination.children.length) {
        pagination.innerHTML = this.slides
          .map((_, index) => `<li><button class="splide__pagination__page" type="button" aria-label="Go to slide ${index + 1}" data-index="${index}"></button></li>`)
          .join("");
      }

      this.prevButton = this.querySelector(".splide__arrow--prev");
      this.nextButton = this.querySelector(".splide__arrow--next");
      this.dots = Array.from(this.querySelectorAll(".splide__pagination__page"));
    }

    bind() {
      this.prevButton && this.prevButton.addEventListener("click", () => this.prev());
      this.nextButton && this.nextButton.addEventListener("click", () => this.next());
      this.dots.forEach((dot) => dot.addEventListener("click", () => this.go(Number(dot.dataset.index))));

      this.addEventListener("keydown", (event) => {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          this.isRtl ? this.next() : this.prev();
        }
        if (event.key === "ArrowRight") {
          event.preventDefault();
          this.isRtl ? this.prev() : this.next();
        }
      });
      this.setAttribute("tabindex", "0");

      let startX = 0;
      let startScroll = 0;
      let dragging = false;
      this.track.addEventListener("pointerdown", (event) => {
        dragging = true;
        startX = event.clientX;
        startScroll = this.track.scrollLeft;
        this.track.setPointerCapture(event.pointerId);
      });
      this.track.addEventListener("pointermove", (event) => {
        if (!dragging || this.fade) return;
        this.track.scrollLeft = startScroll - (event.clientX - startX);
      });
      this.track.addEventListener("pointerup", (event) => {
        if (!dragging) return;
        dragging = false;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 35) {
          delta < 0 ? this.next() : this.prev();
        } else {
          this.go(this.index);
        }
      });

      this._resize = () => this.go(this.index, false);
      window.addEventListener("resize", this._resize);
    }

    prev() {
      this.go(this.index - 1);
    }

    next() {
      this.go(this.index + 1);
    }

    go(nextIndex, animate = true) {
      if (nextIndex < 0) nextIndex = this.loop ? this.slides.length - 1 : 0;
      if (nextIndex >= this.slides.length) nextIndex = this.loop ? 0 : this.slides.length - 1;
      this.index = nextIndex;

      this.slides.forEach((slide, index) => {
        slide.classList.toggle("is-active", index === this.index);
        slide.setAttribute("aria-hidden", index === this.index ? "false" : "true");
      });

      this.dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === this.index);
        dot.setAttribute("aria-current", index === this.index ? "true" : "false");
      });

      if (!this.loop) {
        this.prevButton && (this.prevButton.disabled = this.index === 0);
        this.nextButton && (this.nextButton.disabled = this.index === this.slides.length - 1);
      }

      if (!this.fade) {
        const active = this.slides[this.index];
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        this.list.style.transitionDuration = animate ? "0.35s" : "0s";
        this.track.scrollTo({ left: Math.max(active.offsetLeft - padding, 0), behavior: animate ? "smooth" : "auto" });
      }

      if (this.splide.dataset.desktopAdaptiveHeight === "true" || this.splide.dataset.mobileAdaptiveHeight === "true") {
        const container = this.slides[this.index].querySelector(".splide__slide__container") || this.slides[this.index];
        this.track.style.height = `${container.offsetHeight}px`;
      }
    }
  }

  customElements.define("splide-component", SplideComponent);
})();
